export enum CountryTaxType {
    GST = 'gst',
    EU = 'eu',
    OTHER = 'other',
    EMPTY = ''
}
